@if (this.cognitoService.userType === 'distributor') {
<app-distributor-bins-dashboard></app-distributor-bins-dashboard>
}
@if (this.cognitoService.userType === 'client') {
<app-client-bin-dashboard></app-client-bin-dashboard>
}
